import { Null } from "../null";
import { CheckSquare2, SquareX } from "lucide-react";

export default function ValidationIcon({
  value,
  reverse,
}: {
  value?: boolean | null;
  reverse?: boolean;
}) {
  if (value === null || value === undefined) {
    return <Null />;
  }

  const resolvedValue = reverse ? !value : value;

  if (resolvedValue === true) {
    return <CheckSquare2 color="#5dee7a" />;
  }

  if (resolvedValue === false) {
    return <SquareX color="#f44336" />;
  }

  return <span>undefined value</span>;
}
